import {UnauthorizedState} from './states/unauthorizedState';
import {UnauthorizedController} from './controllers/unauthorizedController';
import './unauthorized.css';

let appModule = angular.module('deliveryCreate.app');
appModule.controller('UnauthorizedController', UnauthorizedController);
appModule.config(['$stateProvider', ($stateProvider: ng.ui.IStateProvider) => {
    $stateProvider.state(UnauthorizedState);
}]);


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/unauthorized/bootstrap.ts
 **/